import {
  Plus,
} from "lucide-react";
import {
  can,
} from "../../shared/auth/access";
import {
  ModuleHeader,
} from "../../shared/components/ModuleHeader";
import { SupplierComposer } from "./SupplierComposer";
import { SupplierPortfolio } from "./SupplierPortfolio";
import { SupplierWorkspace } from "./SupplierWorkspace";
import { useSuppliersWorkspace, type SuppliersModuleProps } from "./useSuppliersWorkspace";

export function SuppliersModule(props: SuppliersModuleProps) {
  const model = useSuppliersWorkspace(props);
  const {
    user,
    setComposerOpen,
  } = model;
  return (<>
    <ModuleHeader
      eyebrow="Tedarikçi ağı"
      title="Tedarikçiler"
      description="Tedarikçi kapsamını, iletişim hazırlığını ve teslimat performansını tek yerden yönetin."
      action={
        can(user, "supplier.identity.manage") ? (
          <button
            className="primary-button"
            onClick={() => setComposerOpen(true)}
          >
            <Plus size={16} /> Tedarikçi ekle
          </button>
        ) : undefined
      }
    />
    <SupplierComposer model={model} />
    <SupplierPortfolio model={model} />
    <SupplierWorkspace model={model} />
  </>);
}
